import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ContextService } from '@core/services/core/context.service';
import { ExternalUrlOpenerHelperService } from '@core/services/core/external-url-opener-helper.service';
import { MenuService } from '@core/services/core/menu.service';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mapfre-login-header',
  templateUrl: './mapfre-login-header.component.html',
  styleUrls: ['./mapfre-login-header.component.scss'],
})
export class MapfreLoginHeaderComponent implements OnInit, OnDestroy {
  @ViewChild('particularTab', {static: false}) particularTab: ElementRef;
  @ViewChild('businessTab', {static: true}) businessTab: ElementRef;
  @ViewChild('contactsTab', {static: false}) contactsTab: ElementRef;
  @ViewChild('faqTab', {static: false}) faqTab: ElementRef;

  @Input() scrollMode = false;
  @Input() showFaq = true;
  @Output() clickScroll = new EventEmitter();

  public baseTabUrl = '';
  public tabHovered = '';
  public caretLeft = 0;
  public caretWidth = 0;
  public caretAnimated = false;
  public headerTabs = {
    particular: {
      title: 'CORE.MENU.PARTICULAR',
      url: '/login/particulares'
    },
    business: {
      title: 'CORE.MENU.BUSINESS',
      url: '/login/empresas'
    },
    contact: {
      title: 'CORE.MENU.PROFILE',
      url: this.ctx.isAccessTypeParticular
        ? '/support'
        : '/login/empresas/contacto'
    },
    faq: {
      title: 'CORE.MENU.FAQ',
      url: '/login/empresas/faq'
    }
  };

  private resize$: Subscription;
  private baseTab: any;

  get particularTabElement() {
    return this.particularTab.nativeElement;
  }

  get businessTabElement() {
    return this.businessTab.nativeElement;
  }

  get contactsTabElement() {
    return this.contactsTab.nativeElement;
  }

  get faqTabElement() {
    return this.faqTab.nativeElement;
  }

  constructor(
    public nav: NavigationHelper,
    public router: Router,
    private ctx: ContextService,
    private platform: Platform,
    private menuService: MenuService,
    private urlExternal: ExternalUrlOpenerHelperService
  ) {}

  ngOnInit() {
    this.menuService.pwaHeaderActive = false;
    this.screenResizeSubscribe();
    setTimeout(() => {
      this.setupBaseTab();
      this.moveCaretToTab(this.baseTab);
      setTimeout(() => {
        this.caretAnimated = true;
      }, 600);
    }, 100);
  }

  ngOnDestroy(): void {
    this.resize$.unsubscribe();
  }


  onEnterTab(element: HTMLElement, elementId: string) {
    this.tabHovered = elementId.split('?')[0];
    this.moveCaretToTab(element);
  }

  onLeaveTab() {
    this.tabHovered = '';
    this.moveCaretToTab(this.baseTab);
  }

  onClickScroll() {
    this.clickScroll.emit();
  }

  goToPortalHome() {
    this.urlExternal.openExternalUrl('https://www.mapfre.es', null, null, { web: { sameTab: true }});
  }

  private moveCaretToTab(element: HTMLElement) {
    if (!!element) {
      const rect = element.getBoundingClientRect();
      this.caretLeft = rect.left;
      this.caretWidth = rect.width;
    }
  }

  private screenResizeSubscribe() {
    this.resize$ = this.platform.resize.subscribe(() => {
      if (this.platform.width() > 960) {
        this.caretAnimated = false;
        this.moveCaretToTab(this.baseTab);
        setTimeout(() => {
          this.caretAnimated = true;
        }, 600);
      }
    });
  }

  private setupBaseTab() {
    this.baseTabUrl = this.router.url.split('?')[0];
    if (this.baseTabUrl === this.headerTabs.particular.url) {
      this.baseTab = this.particularTabElement;
    }
    if (this.baseTabUrl === this.headerTabs.business.url) {
      this.baseTab = this.businessTabElement;
    }
    if (this.baseTabUrl === this.headerTabs.contact.url) {
      this.baseTab = this.contactsTabElement;
    }
    if (this.baseTabUrl === this.headerTabs.faq.url) {
      this.baseTab = this.faqTabElement;
    }
  }
}
